import * as React from 'react';
import { cn } from '@shared/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

const fieldClassName =
  'flex w-full rounded-lg border border-border bg-background text-sm text-foreground px-3 py-2 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]';

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => (
    <div className="w-full">
      <textarea
        ref={ref}
        className={cn(fieldClassName, 'min-h-[100px] resize-y', error && 'border-destructive focus-visible:ring-destructive', className)}
        {...props}
      />
      {error && <p className="mt-1.5 text-xs text-destructive">{error}</p>}
    </div>
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
